module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+MDA4ODU2OEItQTFCMi00MjZDLTgzQTUtQjRCMTZGMjUyNjVCPC90aXRsZT48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48cGF0aCBkPSJNMTkgM0g1Yy0xLjEgMC0yIC45LTIgMnYxNGMwIDEuMS45IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bS05IDE0bC01LTQuODA4IDEuNC0xLjM0NiAzLjYgMy40NjJMMTcuNiA3IDE5IDguMzQ2IDEwIDE3eiIgZmlsbD0iIzQ3ODZmZiIvPjwvZz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ../ui-components/components/Checkbox/on.svg
// module id = 2235
// module chunks = 1